import { useState } from 'react';
import { DialogsApi } from '../../../services/modules/dialogs';
import { Dialog } from 'primereact/dialog';
import { ListBox } from 'primereact/listbox';
import { Button } from 'primereact/button';
import { IDialogParams } from '../api/types/dialog.interface';

export const CreateChoiceListDialog = ({
  show,
  close,
  params,
}: IDialogParams<any>) => {
  const [selectedChannel, setSelectedChannel] =
    useState<DialogsApi.TCreateChoiceListItem | null>(null);
  const applyChanges = async () => {
    if (selectedChannel) {
      const result = await DialogsApi.setChoiceResult({
        selectionList: selectedChannel.data,
      });

      if (result) {
        close();
      }
    }
  };

  return (
    <Dialog
      dismissableMask
      header={params.selectionList.caption}
      visible={show}
      style={{
        width: 460,
      }}
      onHide={close}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
        }}
      >
        <ListBox
          filter
          value={selectedChannel}
          virtualScrollerOptions={{ itemSize: 38 }}
          onChange={(e) => setSelectedChannel(e.value)}
          options={params.selectionList.list}
          optionLabel="name"
          filterInputProps={{
            style: {
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: '14px',
              color: '#334155',
              paddingTop: '8px',
              paddingBottom: '7px',
            },
          }}
          listStyle={{
            height: '250px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '14px',
            color: '#334155',
            padding: 0,
          }}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: 10,
            justifyContent: 'end',
          }}
        >
          <Button
            severity="secondary"
            size="small"
            onClick={close}
            label="Отмена"
          />
          <Button
            onClick={applyChanges}
            size="small"
            disabled={!selectedChannel}
            label="Перенести"
          />
        </div>
      </div>
    </Dialog>
  );
};
